import { useInstance } from '@meraki-internal/react-dependency-injection';
import { AutoStoppingCarousel } from './support/AutoStoppingCarousel';
import { DataModelV2 } from './data';

const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 5
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 4
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 3
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 2
    }
};

export const OurSponsors: React.FC = () => {
    const data = useInstance(DataModelV2);

    return (

        <section className="section-content-block" id="sponsors">

            <div className="container wow fadeIn">

                <div className="row section-heading-wrapper">
                    <div className="col-lg-12 col-md-12 col-sm-12 text-left no-padding">
                        <h2>Our <span>sponsors</span></h2>
                        <h4>Competitive Robotics in the Black Hills wouldn't be possible without financial support from the community.</h4>
                    </div>
                </div>

                <div className="row">

                    <div className="logo-layout-2" id="sponsor-list">
                        <AutoStoppingCarousel responsive={responsive}
                            autoPlaySpeed={1500}
                            infinite
                            >
                            {data.getShuffledSponsors().map(s => (
                                <div key={s.logoPath}>
                                    <div className="client-logo">
                                        <img src={s.logoPath} alt="" />
                                    </div>
                                </div>
                            ))}
                        </AutoStoppingCarousel>
                    </div>

                </div>

            </div>

        </section>
    );
}